"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _Callout = _interopRequireDefault(require("../../elements/Callout/Callout"));
var _TwelveColumnGrid = _interopRequireDefault(require("../Grid/TwelveColumnGrid/TwelveColumnGrid"));
var _excluded = ["dataPoint", "dataDescription"];
var _templateObject, _templateObject2;
var StyledDataCallout = (0, _styledComponents.default)(_TwelveColumnGrid.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  /* text-align: center;\n  border-color: var(--bf-core-teal);\n  border-style: solid;\n  border-width: 3px;\n  border-radius: 40px;\n\n  @media (min-width: ", ") {\n    border-width: 5px;\n  }\n\n  @media (min-width: ", ") {\n    border-width: 7px;\n  } */\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var StyledDataCalloutItem = (0, _styledComponents.default)(_TwelveColumnGrid.default.Item)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  padding: 16px !important;\n  text-align: center;\n  border-color: var(--bf-core-teal);\n  border-style: solid;\n  border-width: 3px;\n  border-radius: 40px;\n\n  @media (min-width: ", ") {\n    padding: 24px !important;\n    border-width: 5px;\n  }\n\n  @media (min-width: ", ") {\n    padding: 32px !important;\n    border-width: 7px;\n  }\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var DataCallout = function DataCallout(_ref) {
  var dataPoint = _ref.dataPoint,
    dataDescription = _ref.dataDescription,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(StyledDataCallout, {
    container: true,
    justifyContent: 'center',
    spansFullPage: true
  }, _react.default.createElement(StyledDataCalloutItem, {
    xs: 12,
    md: 9,
    zeroMinWidth: true,
    justifyContent: 'center',
    alignItems: "center"
  }, _react.default.createElement(_Callout.default, {
    medium: true,
    teal: true,
    noWrap: true
  }, " ", dataPoint), _react.default.createElement(_Heading.default, {
    h3: true,
    teal: true,
    noWrap: true
  }, " ", dataDescription, " ")));
};
var _default = DataCallout;
exports.default = _default;